var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AntTable',{attrs:{"columns":_vm.itemColumns,"data-source":_vm.items,"pagination":{
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100'],
    },"row-key":"id"},scopedSlots:_vm._u([{key:"expandedRowRender",fn:function(ref){
    var responseOptions = ref.responseOptions;
return [_c('AntTable',{attrs:{"row-key":"id","pagination":false,"columns":_vm.responseColumns,"data-source":_vm.orderBy(responseOptions, 'itemScore')}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }